<app-overlay (overlayClick)="onModalClose()">
  <div class="app-modal" [style.width]="width">

    <!-- header -->
    <div class="app-modal-header">

      <div class="app-modal-title">
        <div *ngIf="modalIcon" class="app-modal-icon">
          <span class="google-icon notranslate">{{ modalIcon }}</span>
        </div>
        <div class="app-modal-title-text ellipsis">
          @if (modalTitle && modalTitleCode) {
            <span class="text-capitalize" [appI18n]="{ code: modalTitleCode, default: modalTitle }"></span>
          }
          @else {
            <span class="text-capitalize" [innerHTML]="modalTitle"></span>
          }
        </div>
      </div>

      <button class="app-modal-close" [disabled]="disableButtons()" (click)="onModalClose()">
        <span class="material-icons-round notranslate">close</span>
      </button>
    </div>

    <!-- body -->
    <div class="app-modal-body thin-scrollbar"
      cdkScrollable
      [style.max-height]="'calc(' + height + ' - ' + modalHeaderHeight + ' - ' + modalFooterHeight + ')'"
    >
      <ng-content></ng-content>
    </div>

    <!-- footer -->
    <div class="app-modal-footer">
      <ng-content select="button.modal-button"></ng-content>
    </div>
  </div>
</app-overlay>
